import { PageLayout } from '@/components/page-layout';
import { LATEST_QUEST_BANNER_ID } from '@/constants/shared';
import { useHomeBanner } from '@/hooks/useHomeBanner';
import { useQuests } from '@/hooks/useQuests';
import { SimpleGrid } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { QuestCard } from '../../components/quest-card';
import { LatestQuestCard } from './LatestQuestCard';

export const Quests = () => {
  const { dismissBannerId } = useHomeBanner();

  useEffect(() => {
    dismissBannerId(LATEST_QUEST_BANNER_ID);
  }, [dismissBannerId]);
  const { allQuests, headerQuest } = useQuests();

  return (
    <PageLayout title="Level Up" tertiaryTitle="Complete quests, learn about Plume, earn yields and Plume Points!">
      {headerQuest && <LatestQuestCard quest={headerQuest} />}
      <SimpleGrid
        columns={{
          base: 1,
          md: 1,
          lg: 2,
          xl: 3,
          '2xl': 3,
        }}
        gap={6}
        w="full"
      >
        {allQuests &&
          allQuests
            .filter((quest) => quest.id !== headerQuest?.id)
            .sort((a, b) => dayjs(a.wave).diff(dayjs(b.wave))) // ascending quest order
            .map((quest) => <QuestCard key={quest.id} quest={quest} source="quests-page" />)}
      </SimpleGrid>
    </PageLayout>
  );
};
